<template>
  <span>
    User is already active. To request a demo <br>
    <router-link
      :to="{ name: 'login' }"
      class="login-link"
    >please click here to login.</router-link>
  </span>
</template>

<style lang="less" scoped>
.login-link {
  font-weight: 500;
}
</style>
